import type { IftuneConf } from "@warrenio/api-spec/spec.oats.gen";

export const adminNetworkIftuneExample: IftuneConf = {
    average_kbps: 0,
    peak_kbps: 0,
    burst_kb: 0,
};
